document.addEventListener("DOMContentLoaded", function () {
  const selectElement = document.getElementById("SortBy");

  function adjustSelectWidth() {
    const tempOption = document.createElement("span");
    tempOption.style.visibility = "hidden";
    tempOption.style.whiteSpace = "nowrap";
    tempOption.style.position = "absolute";
    tempOption.style.font = window.getComputedStyle(selectElement).font;
    tempOption.textContent = selectElement.options[selectElement.selectedIndex].text;

    document.body.appendChild(tempOption);
    selectElement.style.width = `${tempOption.offsetWidth + 20}px`; // Add padding
    document.body.removeChild(tempOption);
  }

  // Adjust width on load and when the selection changes
  adjustSelectWidth();
  selectElement.addEventListener("change", adjustSelectWidth);
});